'use client';

import { useParams, usePathname, useRouter } from 'next/navigation';
import { languages, languageNames, languageFlags, cookieName } from '@/i18n/settings';
import { replaceLanguageInPath } from '@/lib/i18n-helpers';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import Cookies from 'js-cookie';

export default function LanguageSwitcherPublic() {
  const params = useParams();
  const pathname = usePathname();
  const router = useRouter();
  const currentLng = (params?.lng as string) || 'en';

  const handleLanguageChange = (newLng: string) => {
    // Set cookie for language preference
    Cookies.set(cookieName, newLng, { expires: 365 });

    // Navigate to new language path
    const newPath = replaceLanguageInPath(pathname, newLng);
    router.push(newPath);

    // Refresh to reload all server components with new language
    router.refresh();
  };

  return (
    <div className="absolute top-4 right-4">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="gap-2" aria-label="public-language-selector">
            <Globe className="h-4 w-4" />
            <span className="hidden sm:inline">{languageNames[currentLng]}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {languages.map((lng) => (
            <DropdownMenuItem
              key={lng}
              onClick={() => handleLanguageChange(lng)}
              className={currentLng === lng ? 'bg-accent' : ''}
              aria-label={`language-${lng}`}
            >
              <span className="mr-2">{languageFlags[lng]}</span>
              <span>{languageNames[lng]}</span>
              {currentLng === lng && (
                <span className="ml-auto text-xs">✓</span>
              )}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
